module.exports = __webpack_public_path__ + "static/media/noAnnouncementIcon.bd111f8f.svg";